<div class="container">
  <div class="card">
    <div class="d-flex flex-row justify-content-end form-group mt-2 mb-5">
      <div>
        <button (click)="back()" class="btn btn-standard action-btn" type="button">
          <i class="fa fa-arrow-left"></i> Back
        </button>
      </div>
    </div>
    <div [hidden]="!isEditUserLoggedIn()" class="card-text col-md-12">
      <br>
        <h3>Note: role and access configuration for your own account is not allowed.</h3><br>
      </div>

      <form [formGroup]="form">
        <div class="card col-md-12">
          <div class="card-header">
            <h2 class="orange-border">
                        Users Details <i class="pi pi-question-circle tooltip-icon" pTooltip="Updating a user's email address will affect their login credentials.
                                Once an email address has been updated for a user, the user will have to login with
                                their new email address once logged out."></i>
          </h2>

        </div>
        <div class="card-body">
          <div class="row">
            <div class="form-group col-md-6">
              <label for="name"><h3>Name:</h3></label>
              <input [ngClass]="{ 'is-invalid': displayError(f.name)}"
                class="form-control"
                formControlName="name"
                id="name"
                placeholder="Name"
                type="text"/>
              @if (displayError(f.name)) {
                <div class="invalid-feedback">
                  @if (f.name.errors.required) {
                    <div>Name is required</div>
                  }
                </div>
              }
            </div>

            <div class="form-group col-md-6">
              <label for="surname"><h3>Surname:</h3></label>
              <input [ngClass]="{ 'is-invalid': displayError(f.surname) }"
                class="form-control"
                formControlName="surname"
                id="surname"
                placeholder="Surname"
                type="text"/>
              @if (displayError(f.surname)) {
                <div class="invalid-feedback">
                  @if (f.surname.errors.required) {
                    <div>Surname is required</div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <label for="email"><h3>Email:</h3></label>
              <input [ngClass]="{ 'is-invalid': displayError(f.email) }"
                class="form-control"
                formControlName="email"
                id="email"
                placeholder=""
                type="text"/>
              @if (displayError(f.email)) {
                <div class="invalid-feedback">
                  @if (f.email.errors.required) {
                    <div>Email is required</div>
                  }
                  @if (f.email.errors.email) {
                    <div>Invalid email</div>
                  }
                  @if (f.email.errors.duplicateEmail) {
                    <div>
                      A user with this email address already exists
                    </div>
                  }
                </div>
              }
            </div>

            <div class="form-group col-md-6">
              <validation [formGroup]="form" controlName="mobileNumber" displayName="Mobile number">
                <label for="mobile-number"><h3>Mobile Number:</h3></label>
                <input [ngClass]="{ 'is-invalid': displayError(f.mobileNumber) }"
                  class="form-control"
                  formControlName="mobileNumber"
                  id="mobile-number"
                  placeholder="0831234567 or +27831234567"
                  pTooltip="The contact details of the main user of this profile."
                  type="tel"/>
              </validation>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-6">
              <validation [formGroup]="form" controlName="agentId" displayName="Agent ID">
                <label for="agentId"><h3>Agent ID:</h3></label>
                <input [ngClass]="{ 'is-invalid': displayError(f.agentId) }"
                  class="form-control"
                  formControlName="agentId"
                  id="agentId"
                  placeholder="10-14 alphanumeric characters"
                  pTooltip="Unique agent identifier (10-14 alphanumeric characters)"
                  type="text"
                  maxlength="14"/>
              </validation>
            </div>
          </div>
        </div>
      </div>

      <div [hidden]="isEditUserLoggedIn()" class="card col-md-12">
        <div class="card-header">
                    <h2 class="orange-border">Access <i class="pi pi-question-circle tooltip-icon" pTooltip="Once a user has been disabled, they will no longer be able to login to and
                        access the system. This will not terminate their account. Users that have been disabled
                        can be re-enabled again at any time."></i>
        </h2>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="form-group col-sm-6">
            <div class="form-check">
              <h3>
                <input class="form-check-input"
                  formControlName="enabled"
                  id="enabled"
                  type="checkbox"> <label class="form-check-label" for="enabled">
                Enabled </label></h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <app-role-selector (outputRole)="onRoleSelect($event)"
      [defaultRoleSubject]="getRoleSubject()"
    [hidden]="isEditUserLoggedIn()"></app-role-selector>
    <div class="row">
      <div class="col-md-12 text-center">
        <button (click)="onSubmit()" [disabled]="loading" class="navy-btn center">
          Save <i [hidden]="!loading" class="fa fa-spinner fa-spin" style="font-size:15px"></i>
        </button>
      </div>
    </div>
  </div>
</div>
<ngx-ui-loader></ngx-ui-loader>